<template>
  <div v-if="visible && currentNotification" class="modal fade show d-block campaign-modal-backdrop" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-dialog-centered campaign-modal-dialog">
      <div class="modal-content campaign-modal-card">
        
        <!-- Header / Modal Kapatma -->
        <div class="campaign-modal-header">
          <span class="campaign-badge">
            <i class="bi bi-stars me-1"></i> SANA ÖZEL FIRSAT
          </span>
          <button v-if="currentNotification.isShowCloseButton" type="button" class="btn-close-custom" @click="handleClose" aria-label="Kapat">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <!-- Modal Gövdesi -->
        <div class="modal-body campaign-modal-body text-center">
          <div class="campaign-icon-wrapper mb-3">
            <i class="bi bi-gift-fill"></i>
          </div>
          <h3 class="campaign-title">{{ currentNotification.title }}</h3>
          
          <!-- Zengin Metin İçeriği -->
          <div class="campaign-content" v-html="currentNotification.content"></div>
        </div>

        <!-- Aksiyon Butonları -->
        <div class="modal-footer campaign-modal-footer">
          <!-- İlgilenmiyorum -->
          <button 
            v-if="currentNotification.isShowNotInterestedButton" 
            type="button" 
            class="btn btn-outline-secondary campaign-btn-action" 
            @click="handleAction('not_interested')">
            İlgilenmiyorum
          </button>

          <!-- Daha Sonra Hatırlat -->
          <button 
            v-if="currentNotification.isShowRemindMeLaterButton" 
            type="button" 
            class="btn btn-light campaign-btn-action" 
            @click="handleAction('remind_later')">
            <i class="bi bi-clock-history me-1"></i> Daha Sonra
          </button>

          <!-- İlgileniyorum (Primary Action) -->
          <button 
            v-if="currentNotification.isShowInterestedButton !== false" 
            type="button" 
            class="btn btn-success campaign-btn-primary" 
            @click="handleAction('interested')">
            Hemen İncele <i class="bi bi-arrow-right ms-1"></i>
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { SetCookie } from "@/common/cookie-helper";

export default {
  name: "StudentCampaignModal",
  props: {
    notification: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      currentNotification: null
    };
  },
  watch: {
    notification: {
      immediate: true,
      handler(val) {
        if (val) {
          this.currentNotification = val;
          this.visible = true;
        } else {
          this.visible = false;
        }
      }
    }
  },
  methods: {
    handleClose() {
      this.visible = false;
      this.$emit("close", this.currentNotification);
    },
    handleAction(actionType) {
      if (!this.currentNotification) return;

      const durationMinutes = this.currentNotification.remindMeLaterDuration || 1440; // varsayılan 24 saat

      if (actionType === 'remind_later') {
        if (this.currentNotification.cookieKey) {
          SetCookie(this.currentNotification.cookieKey, 'true', durationMinutes);
        }
      } else if (actionType === 'not_interested') {
        if (this.currentNotification.cookieKey) {
          SetCookie(this.currentNotification.cookieKey, 'dismissed', 30 * 24 * 60); // 30 gün gizle
        }
      } else if (actionType === 'interested') {
        // İlgilenildi durumunda market sayfasına yönlendir veya bildirimi kapat
        if (this.$route.path !== '/market') {
          this.$router.push('/market');
        }
      }

      this.visible = false;
      this.$emit("action", { notification: this.currentNotification, actionType });
    }
  }
};
</script>

<style scoped>
.campaign-modal-backdrop {
  background-color: rgba(18, 38, 26, 0.55);
  backdrop-filter: blur(4px);
  z-index: 1055;
}

.campaign-modal-dialog {
  max-width: 480px;
  margin: 1.75rem auto;
}

.campaign-modal-card {
  border: 0;
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(15, 43, 26, 0.25);
  overflow: hidden;
  background: #ffffff;
}

.campaign-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 8px;
}

.campaign-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  background: #eef7f2;
  color: var(--brand-link);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.btn-close-custom {
  background: #f4f7f4;
  border: 0;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #526357;
  cursor: pointer;
  transition: all 150ms ease;
}

.btn-close-custom:hover {
  background: #e4ebe6;
  color: #20372b;
}

.campaign-modal-body {
  padding: 16px 28px 24px;
}

.campaign-icon-wrapper {
  width: 64px;
  height: 64px;
  margin: 0 auto;
  border-radius: 20px;
  background: linear-gradient(135deg, #e7f5eb, #d2ebd9);
  color: var(--brand-link);
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.campaign-title {
  font-size: 22px;
  font-weight: 750;
  color: #20372b;
  margin-bottom: 12px;
  letter-spacing: -0.5px;
}

.campaign-content {
  font-size: 14px;
  line-height: 1.6;
  color: #526357;
}

.campaign-modal-footer {
  padding: 16px 24px 24px;
  border-top: 1px solid #f0f4f1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.campaign-btn-action {
  border-radius: 12px;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 600;
}

.campaign-btn-primary {
  border-radius: 12px;
  padding: 10px 20px;
  font-size: 13px;
  font-weight: 700;
  background: var(--brand-link);
  border: 0;
  box-shadow: 0 4px 12px rgba(40, 131, 60, 0.25);
  transition: background 150ms ease;
}

.campaign-btn-primary:hover {
  background: #206c31;
}

@media (max-width: 576px) {
  .campaign-modal-dialog {
    margin: 12px;
  }
  .campaign-modal-footer {
    flex-direction: column-reverse;
  }
  .campaign-modal-footer .btn {
    width: 100%;
  }
}
</style>
